module.exports = __webpack_public_path__ + "static/media/approach-marketing.91b3dbf6.svg";